module.exports = __webpack_public_path__ + "img/product_stkr_best.9834fa2d.svg";